<div class="info">
  <em class="icon-ico-protip">
    <span class="path1"></span><span class="path2"></span><span class="path3"></span>
  </em>
  <div class="info__tip">
    <h2 class="info__tip--title font-bold">Pro tip!</h2>
    <ul class="mb-0" *ngIf="protipBullet">
      <li *ngFor="let tip of tips">{{tip}} </li>
      <li *ngIf="protip && protip.link"><a [href]="protip.link" class="text-underline"
          target="{{protip.target}}">{{protip.linkDesc}}</a></li>
    </ul>

    <ng-container *ngIf="!protipBullet">
      <p *ngFor="let tip of tips; last as isLast">
        {{tip}} <span *ngIf="protip && protip.link && isLast"><button class="btn btn-clear text-underline"
            (click)="navigate(protip.link)">{{protip.linkDesc}}</button></span>
      </p>
    </ng-container>

    <ng-container *ngIf="showMath">
      <p class="mb-0 font-2x">To create a math equation in the Textarea, use any one of the following patterns,
        <span class="d-block">
          <span><strong>`</strong><em class="font-2x">math equation</em><strong>`</strong></span>,&nbsp;
          <span><strong>$</strong><em class="font-2x">math equation</em><strong>$</strong></span>,&nbsp;
          <span><strong>\(</strong><em class="font-2x">math equation</em><strong>\)</strong></span>
        </span>
      </p>
    </ng-container>
  </div>
</div>